// import { Product } from 'pages/Product';
import Client from '../Client.provider';
import {
  iEventRest,
  iFormAnswers,
  iFormQuestion,
  iInvite,
  iEventExtraField,
} from './Event.type';

export type EventPageType = 'editor_d_offer' | 'editeur_site_web';

export interface iEventRepository {
  getEvents: () => Promise<iEventRest[]>;
  getEventById: (eventId: string) => Promise<iEventRest>;
  // getEvent: (idEvent: string) => Promise<iEventRest>;
  mergeEvent: (type: any, value: any, eventId: number) => Promise<boolean>;
  createEvent: (data: any) => Promise<boolean>;
  acceptInvite: (data: any) => Promise<boolean>;
  updateFormInformation: (data: any, eventId: string) => Promise<boolean>;
  getFormInformation: (eventId: string | undefined) => Promise<iFormQuestion[]>;
  remove: (eventId: string) => Promise<boolean>;
  updateFormAnswers: (
    questionId: number,
    data: iFormAnswers
  ) => Promise<iFormQuestion>;
  inviteEvent: (eventId: string | undefined, form: iInvite) => Promise<any>;
  removeQuestion: (questionId: number) => Promise<boolean>;
  inviteExhibitor: (eventId: string | undefined, data: any) => Promise<any>;
  fetchEventExtraFields: (eventId: string) => Promise<iEventExtraField>;
  createCopyEvent: (eventId: string) => Promise<iEventRest>;
  getPublicEvents: () => Promise<iEventRest[]>;
  getPublicEventBySlug: (slug: string) => Promise<any[]>;
  addPage: (eventId: string, data: any, type?: EventPageType) => Promise<any>;
  getEventPage: (eventId: string, type?: EventPageType) => Promise<any>;
  publishEventPage: (
    eventId: string,
    data: any,
    type?: EventPageType
  ) => Promise<any>;
  unpublishEventPage: (eventId: string, type?: EventPageType) => Promise<any>;
  getPublicEventPageBySlug: (slug: string) => Promise<any>;
  publicSiretLookup: (siret: string) => Promise<any>;
  createPublicOrder: (slug: string, payload: any) => Promise<any>;
  listOrders: (eventId: string) => Promise<any[]>;
  updateOrderStatus: (
    orderId: number,
    status: string,
    notes?: string
  ) => Promise<any>;
  hideOrder: (orderId: number) => Promise<any>;
  submitEventForm: (
    basePath: string,
    slug: string,
    formJson: Record<string, any>
  ) => Promise<any>;
  getConnectorAdmins: (eventId: string | undefined) => Promise<any[]>;
  getAvailableConnectorAdmins: (eventId: string | undefined) => Promise<any[]>;
  addConnectorAdmins: (
    eventId: string | undefined,
    adminIds: Array<string | number>
  ) => Promise<any>;
  removeConnectorAdmin: (
    eventId: string | undefined,
    adminId: string | number
  ) => Promise<any>;
  getConnectorModerators: (eventId: string | undefined) => Promise<any[]>;
  getAvailableConnectorModerators: (
    eventId: string | undefined
  ) => Promise<any[]>;
  addConnectorModerators: (
    eventId: string | undefined,
    moderatorIds: Array<string | number>
  ) => Promise<any>;
  removeConnectorModerator: (
    eventId: string | undefined,
    moderatorId: string | number
  ) => Promise<any>;
}
const pathSegments = window.location.pathname.split('/');
const dynamicSegment = pathSegments[1];
const BASE_PATH = window.location.pathname.split('/')[1];
export class EventRepository extends Client implements iEventRepository {
  public async getEvents(): Promise<iEventRest[]> {
    return await this.restricted()
      .get<iEventRest[]>(`/event`)
      .then((e) => e.data)
      .catch((error) => {
        throw new Error(
          error.response.data.message ||
            `${error.response.status} | Unknow error...`
        );
      });
  }

  public async getFormInformation(
    eventId: string | undefined
  ): Promise<iFormQuestion[]> {
    return await this.restricted()
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      .get<iFormQuestion[]>(`/event/iform/${eventId}`)
      .then((e) => e.data)
      .catch((error) => {
        throw new Error(
          error.response.data.message ||
            `${error.response.status} | Unknow error...`
        );
      });
  }

  public async acceptInvite(code: string): Promise<boolean> {
    return await this.restricted()
      .get(`/accept/${code}`)
      .then((e) => e.data)
      .catch((error) => {
        throw new Error(
          error.response.data.message ||
            `${error.response.status} | Unknow error...`
        );
      });
  }

  public async inviteEvent(
    eventId: string | undefined,
    form: iInvite
  ): Promise<any> {
    return await this.restricted()
      .post(`/${BASE_PATH}/invite/${eventId !== undefined ? eventId : 0}`, form)
      .then((e) => e.data)
      .catch((error) => {
        throw new Error(
          error.response.data.message ||
            `${error.response.status} | Unknow error...`
        );
      });
  }

  public async inviteExhibitor(
    eventId: string | undefined,
    data: any
  ): Promise<any> {
    return await this.restricted()
      .post(
        `/${BASE_PATH}/invite-exhibitor/${eventId !== undefined ? eventId : 0}`,
        data
      )
      .then((e) => e.data)
      .catch((error) => {
        throw new Error(
          error.response.data.message ||
            `${error.response.status} | Unknow error...`
        );
      });
  }

  public async getEventById(eventId: string): Promise<iEventRest> {
    return await this.restricted()
      .get<iEventRest>(`/event/iform-information/${eventId}`)
      .then((e) => e.data)
      .catch((error) => {
        throw new Error(
          error.response.data.message ||
            `${error.response.status} | Unknow error...`
        );
      });
  }

  public async mergeEvent(
    type: string,
    value: any,
    eventId: number
  ): Promise<boolean> {
    return await this.restricted()
      .put<iEventRest>(`/${BASE_PATH}/event/merge/${eventId}`, {
        [type]: value,
      })
      .then((e) => !e.data)
      .catch((error) => {
        throw new Error(
          error.response.data.message ||
            JSON.stringify(error.response.data)
              .replace(/[{}[\]"]/g, '')
              .replace(/,/g, '<br/>') ||
            `${error.response.status} | Unknow error...`
        );
      });
  }

  public async createEvent(data: any): Promise<boolean> {
    return await this.restricted()
      .put<iEventRest>(`/${dynamicSegment ?? BASE_PATH}/event`, data)
      .then((e) => !e.data)
      .catch((error) => {
        throw new Error(
          error.response.data.message ||
            JSON.stringify(error.response.data)
              .replace(/[{}[\]"]/g, '')
              .replace(/,/g, '<br/>') ||
            `${error.response.status} | Unknow error...`
        );
      });
  }

  public async updateFormInformation(
    data: any,
    eventId: string
  ): Promise<boolean> {
    return await this.restricted()
      .put<iFormQuestion>(`/event/iform/${eventId}`, data)
      .then((e) => !e.data)
      .catch((error) => {
        throw new Error(
          error.response.data.message ||
            JSON.stringify(error.response.data)
              .replace(/[{}[\]"]/g, '')
              .replace(/,/g, '<br/>') ||
            `${error.response.status} | Unknow error...`
        );
      });
  }

  public async updateFormAnswers(
    questionId: number,
    data: iFormAnswers
  ): Promise<iFormQuestion> {
    return await this.restricted()
      .put<iFormQuestion>(`/event/iform-update-questions/${questionId}`, data)
      .then((e) => e.data)
      .catch((error) => {
        throw new Error(
          error.response.data.message ||
            JSON.stringify(error.response.data)
              .replace(/[{}[\]"]/g, '')
              .replace(/,/g, '<br/>') ||
            `${error.response.status} | Unknow error...`
        );
      });
  }

  public async remove(eventId: string): Promise<boolean> {
    return await this.restricted()
      .delete(`/event/${eventId}`)
      .then((e) => !e.data)
      .catch((error) => {
        throw new Error(
          error.response.data.message ||
            JSON.stringify(error.response.data)
              .replace(/[{}[\]"]/g, '')
              .replace(/,/g, '<br/>') ||
            `${error.response.status} | Unknow error...`
        );
      });
  }

  public async removeQuestion(questionId: number): Promise<boolean> {
    return await this.restricted()
      .delete(`/event/iform-update-questions/${questionId}`)
      .then((e) => !e.data)
      .catch((error) => {
        throw new Error(
          error.response.data.message ||
            JSON.stringify(error.response.data)
              .replace(/[{}[\]"]/g, '')
              .replace(/,/g, '<br/>') ||
            `${error.response.status} | Unknow error...`
        );
      });
  }

  public async fetchEventExtraFields(
    exhibitorEventId: string
  ): Promise<iEventExtraField> {
    const response = await this.restricted()
      .get<iEventExtraField>(`/event/extra-fields/${exhibitorEventId}`)
      .catch((error) => {
        throw new Error(
          error.response.data.message ||
            `${error.response.status} | Unknow error...`
        );
      });
    return response.data;
  }

  public async createCopyEvent(eventId: string): Promise<iEventRest> {
    return await this.restricted()
      .get<iEventRest>(`/copy/event/${eventId}/create`)
      .then((e) => e.data)
      .catch((error) => {
        throw new Error(
          error.response.data.message ||
            `${error.response.status} | Unknow error...`
        );
      });
  }

  public async getPublicEvents(): Promise<any[]> {
    return await this.public()
      .get<iEventRest[]>(`/${BASE_PATH}/events`)
      .then((e) => e.data)
      .catch((error) => {
        throw new Error(
          error.response.data.message ||
            `${error.response.status} | Unknow error...`
        );
      });
  }

  public async getPublicEventBySlug(slug: string): Promise<any[]> {
    return await this.public()
      .get<any[]>(`/${BASE_PATH}/events/${slug}`)
      .then((e) => e.data)
      .catch((error) => {
        throw new Error(
          error.response.data.message ||
            `${error.response.status} | Unknow error...`
        );
      });
  }

  public async addPage(
    eventId: string,
    data: any,
    type: EventPageType = 'editor_d_offer'
  ): Promise<any> {
    return await this.restricted()
      .post(`/events/${eventId}/page`, data, { params: { type } })
      .then((e) => e.data)
      .catch((error) => {
        throw new Error(
          error.response.data.message ||
            `${error.response.status} | Unknow error...`
        );
      });
  }

  public async getEventPage(
    eventId: string,
    type: EventPageType = 'editor_d_offer'
  ): Promise<any> {
    return await this.restricted()
      .get(`/events/${eventId}/page`, { params: { type } })
      .then((e) => e.data)
      .catch((error) => {
        throw new Error(
          error.response.data.message ||
            `${error.response.status} | Unknow error...`
        );
      });
  }

  public async publishEventPage(
    eventId: string,
    data: any,
    type: EventPageType = 'editor_d_offer'
  ): Promise<any> {
    return await this.restricted()
      .post(`/events/${eventId}/page/publish`, data, { params: { type } })
      .then((e) => e.data)
      .catch((error) => {
        throw new Error(
          error.response.data.message ||
            `${error.response.status} | Unknow error...`
        );
      });
  }

  public async unpublishEventPage(
    eventId: string,
    type: EventPageType = 'editor_d_offer'
  ): Promise<any> {
    return await this.restricted()
      .post(`/events/${eventId}/page/unpublish`, null, { params: { type } })
      .then((e) => e.data)
      .catch((error) => {
        throw new Error(
          error.response.data.message ||
            `${error.response.status} | Unknow error...`
        );
      });
  }

  public async getPublicEventPageBySlug(slug: string): Promise<any> {
    return await this.public()
      .get(`/${BASE_PATH}/events/${slug}/page`)
      .then((e) => e.data)
      .catch((error) => {
        throw new Error(
          error.response.data.message ||
            `${error.response.status} | Unknow error...`
        );
      });
  }

  public async publicSiretLookup(siret: string): Promise<any> {
    return await this.public()
      .get(`/${BASE_PATH}/public/siret/${siret}`)
      .then((e) => e.data)
      .catch((error) => {
        throw new Error(
          error?.response?.data?.message ||
            `${error?.response?.status ?? ''} | SIRET introuvable`
        );
      });
  }

  public async createPublicOrder(slug: string, payload: any): Promise<any> {
    return await this.public()
      .post(`/${BASE_PATH}/events/${slug}/orders`, payload)
      .then((e) => e.data)
      .catch((error) => {
        throw new Error(
          error?.response?.data?.message ||
            `${error?.response?.status ?? ''} | Erreur lors de la commande`
        );
      });
  }

  public async listOrders(eventId: string): Promise<any[]> {
    return await this.restricted()
      .get(`/events/${eventId}/orders`)
      .then((e) => e.data)
      .catch((error) => {
        throw new Error(
          error?.response?.data?.message ??
            `${error?.response?.status ?? ''} | Unknow error...`
        );
      });
  }

  public async updateOrderStatus(
    orderId: number,
    status: string,
    notes?: string
  ): Promise<any> {
    return await this.restricted()
      .put(`/orders/${orderId}/status`, { status, notes })
      .then((e) => e.data)
      .catch((error) => {
        throw new Error(
          error?.response?.data?.message ??
            `${error?.response?.status ?? ''} | Unknow error...`
        );
      });
  }

  public async hideOrder(orderId: number): Promise<any> {
    return await this.restricted()
      .put(`/orders/${orderId}/hide`)
      .then((e) => e.data)
      .catch((error) => {
        throw new Error(
          error?.response?.data?.message ??
            `${error?.response?.status ?? ''} | Unknow error...`
        );
      });
  }

  public async submitEventForm(
    basePath: string,
    slug: string,
    formJson: Record<string, any>
  ): Promise<any> {
    return await this.public()
      .post(`/${basePath}/events/${slug}/forms`, { form_json: formJson })
      .then((e) => e.data)
      .catch((error) => {
        throw new Error(
          error?.response?.data?.message ||
            `${
              error?.response?.status ?? ''
            } | Erreur lors de la soumission du formulaire`
        );
      });
  }

  public async getConnectorAdmins(eventId: string | undefined): Promise<any[]> {
    return await this.restricted()
      .get<any[]>(
        `/events/${eventId !== undefined ? eventId : 0}/connector-admins`
      )
      .then((e) => e.data)
      .catch((error) => {
        throw new Error(
          error.response.data.message ||
            `${error.response.status} | Unknow error...`
        );
      });
  }

  public async getAvailableConnectorAdmins(
    eventId: string | undefined
  ): Promise<any[]> {
    return await this.restricted()
      .get<any[]>(
        `/events/${
          eventId !== undefined ? eventId : 0
        }/connector-admins/available`
      )
      .then((e) => e.data)
      .catch((error) => {
        throw new Error(
          error.response.data.message ||
            `${error.response.status} | Unknow error...`
        );
      });
  }

  public async addConnectorAdmins(
    eventId: string | undefined,
    adminIds: Array<string | number>
  ): Promise<any> {
    return await this.restricted()
      .post(`/events/${eventId !== undefined ? eventId : 0}/connector-admins`, {
        admin_ids: adminIds,
      })
      .then((e) => e.data)
      .catch((error) => {
        throw new Error(
          error.response.data.message ||
            `${error.response.status} | Unknow error...`
        );
      });
  }

  public async removeConnectorAdmin(
    eventId: string | undefined,
    adminId: string | number
  ): Promise<any> {
    return await this.restricted()
      .delete(
        `/events/${
          eventId !== undefined ? eventId : 0
        }/connector-admins/${adminId}`
      )
      .then((e) => e.data)
      .catch((error) => {
        throw new Error(
          error.response.data.message ||
            `${error.response.status} | Unknow error...`
        );
      });
  }

  public async getConnectorModerators(
    eventId: string | undefined
  ): Promise<any[]> {
    return await this.restricted()
      .get<any[]>(`/events/${eventId ?? 0}/connector-moderators`)
      .then((e) => e.data)
      .catch((error) => {
        throw new Error(
          error.response.data.message ||
            `${error.response.status} | Unknow error...`
        );
      });
  }

  public async getAvailableConnectorModerators(
    eventId: string | undefined
  ): Promise<any[]> {
    return await this.restricted()
      .get<any[]>(`/events/${eventId ?? 0}/connector-moderators/available`)
      .then((e) => e.data)
      .catch((error) => {
        throw new Error(
          error.response.data.message ||
            `${error.response.status} | Unknow error...`
        );
      });
  }

  public async addConnectorModerators(
    eventId: string | undefined,
    moderatorIds: Array<string | number>
  ): Promise<any> {
    return await this.restricted()
      .post(`/events/${eventId ?? 0}/connector-moderators`, {
        moderator_ids: moderatorIds,
      })
      .then((e) => e.data)
      .catch((error) => {
        throw new Error(
          error.response.data.message ||
            `${error.response.status} | Unknow error...`
        );
      });
  }

  public async removeConnectorModerator(
    eventId: string | undefined,
    moderatorId: string | number
  ): Promise<any> {
    return await this.restricted()
      .delete(`/events/${eventId ?? 0}/connector-moderators/${moderatorId}`)
      .then((e) => e.data)
      .catch((error) => {
        throw new Error(
          error.response.data.message ||
            `${error.response.status} | Unknow error...`
        );
      });
  }

  public async generateEventPagePdf(eventId: string): Promise<Blob> {
    return await this.restricted()
      .get(`/events/${eventId}/page/pdf`, {
        responseType: 'blob',
      })
      .then((e) => e.data)
      .catch((error) => {
        throw new Error(
          error.response.data.message ||
            `${error.response.status} | Unknow error...`
        );
      });
  }
}
